type YoutubeEmbedUrlOptions = {
  videoUrl?: string;
  start?: number;
  end?: number;
  noCookie?: boolean;
  autoplay?: boolean;
};

export default function getYoutubeEmbedUrl(videoId: string, options?: YoutubeEmbedUrlOptions) {
  const noCookie = options && options.noCookie ? options.noCookie : true;
  const autoplay = options && options.autoplay ? options.autoplay : false;

  const baseUrl = `https://www.youtube${noCookie ? "-nocookie" : ""}.com/embed/${videoId}?rel=0&${
    autoplay ? "autoplay=1" : ""
  }`;

  if (options && options.start && options.end) {
    return `${baseUrl}&start=${options.start}&end=${options.end}`;
  }

  if (options && options.start) {
    return `${baseUrl}&start=${options.start}`;
  }

  if (options && options.videoUrl) {
    try {
      const url = new URL(options.videoUrl);

      if (url.searchParams.has("t")) {
        const startTime = url.searchParams.get("t");
        return `${baseUrl}&start=${startTime}`;
      }
    } catch {} // eslint-disable-line
  }

  return `${baseUrl}`;
}
